<template>
  <v-container fluid class="page-wrap fill-height">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" sm="10" md="8" lg="6" class="text-center">
        <v-card class="rounded-xl pa-6 pa-md-10" elevation="3">
            <div class="notfound-code mb-2">404</div>
            <div class="text-h6 font-weight-bold primary--text mb-1">Ooops! The page you were looking for couldn't be found</div>
            <div class="text-body-2 grey--text mb-6">It might have been moved, renamed, or never existed. Try one of these instead:</div>

            <v-row dense justify="center">
                <v-col cols="6" sm="4">
                    <v-btn block outlined rounded color="primary" class="text-none font-weight-bold" href="/">
                        <v-icon left>mdi-home-outline</v-icon>
                        Home
                    </v-btn>
                </v-col>
                <v-col cols="6" sm="4">
                    <v-btn block outlined rounded color="primary" class="text-none font-weight-bold" href="/resultsModule/dashboard">
                        <v-icon left>mdi-chart-box-outline</v-icon>
                        Results
                    </v-btn>
                </v-col>
                <v-col cols="6" sm="4">
                    <v-btn block outlined rounded color="primary" class="text-none font-weight-bold" :href="$router.resolve({ name: 'Register' }).href">
                        <v-icon left>mdi-account-plus-outline</v-icon>
                        Register
                    </v-btn>
                </v-col>
                <v-col cols="6" sm="4">
                    <v-btn block outlined rounded color="primary" class="text-none font-weight-bold" :href="$router.resolve({ name: 'Login' }).href">
                        <v-icon left>mdi-login</v-icon>
                        Login
                    </v-btn>
                </v-col>
                <v-col cols="6" sm="4">
                    <v-btn block outlined rounded color="primary" class="text-none font-weight-bold" :href="$router.resolve({ name: 'MultiAccessLogin' }).href">
                        <v-icon left>mdi-key-outline</v-icon>
                        Teacher Access
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'PageNotFound',
    data: () => ({
        //
    }),
    mounted(){
        //
    },
    methods: {
        //
    },
  }
</script>

<style scoped>
.notfound-code {
    font-size: 5rem;
    font-weight: 800;
    line-height: 1;
    background: linear-gradient(135deg, #1E3C72 0%, #2A5298 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}
</style>
